import { ThemeToggle } from '@/shared/components/theme-toggle';
import { isMockEnabled } from '@/mocks';
import { useTranslation } from 'react-i18next';
import { PublicSurveyLanguageSwitcher } from './public-survey-language-switcher';

/** Barra superior fixa: idioma e tema centralizados (+ chip mock se ativo). */
export function PublicSurveyTopBar() {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-50 border-b border-border/50 bg-background/90 backdrop-blur-md">
      <div className="container mx-auto flex max-w-3xl items-center justify-center gap-3 px-4 py-2">
        {isMockEnabled() ? (
          <span className="truncate text-xs font-medium text-primary">{t('topBar.mockLabel')}</span>
        ) : null}
        <PublicSurveyLanguageSwitcher />
        <span className="hidden text-xs text-muted-foreground sm:inline">{t('topBar.theme')}</span>
        <ThemeToggle className="size-9 rounded-lg border border-border/60 bg-background shadow-sm" />
      </div>
    </header>
  );
}
